// Vocabulary: readers see this feature as "owner reviews"; code, routes, DealHunt paths and
// analytics events keep the historical "owner note" name on purpose — do not rename them.

import { PRE_PUBLISH_SIGN_IN } from 'lib/owner-notes/band-copy'
import styles from './OwnerNoteBand.module.css'

interface PrePublishSignInProps {
  /** `useOwnerAuth().showLogIn` — the in-page dialog: the band stays mounted, the draft too. */
  onSignIn: () => Promise<void>
}

/**
 * Step 3's sign-in line for a signed-out reader (`prePublishSignInShown`), in the identity row's
 * box: once the dialog closes signed in, the band re-renders and the identity row takes this
 * slot. The click only opens the dialog — nothing links until Publish (#81).
 */
const PrePublishSignIn: React.VFC<PrePublishSignInProps> = ({ onSignIn }) => (
  <p className={styles.identity}>
    {PRE_PUBLISH_SIGN_IN.lead}
    <button type="button" className={styles.identityToggle} onClick={() => void onSignIn()}>
      {PRE_PUBLISH_SIGN_IN.button}
    </button>
  </p>
)

export default PrePublishSignIn
